import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const DynamicYearSelector = ({ 
  selectedYear, 
  setSelectedYear, 
  minYear, 
  maxYear, 
  isToYear = false, 
  isFinanceReport = false 
}) => {
  const currentYear = new Date().getFullYear();
  
  // Determine the actual max year based on context
  let actualMaxYear = maxYear || currentYear;
  
  // If this is a "to_year" selector for finance reports, allow current year + 1
  if (isToYear && isFinanceReport) {
    actualMaxYear = Math.max(actualMaxYear, currentYear + 1);
  }
  
  // Determine the min year (default to 6 years back if not specified)
  const actualMinYear = minYear || (currentYear - 5);
  
  // Generate year options from min to max
  const yearRange = actualMaxYear - actualMinYear + 1;
  const yearOptions = Array.from(
    { length: yearRange },
    (_, index) => actualMinYear + index
  ).reverse(); // Reverse to show newest years first

  return (
    <FormControl size="small" sx={{ minWidth: 100 }}>
      <InputLabel>Year</InputLabel>
      <Select
        value={selectedYear}
        onChange={(e) => setSelectedYear(Number(e.target.value))}
        label="Year"
      >
        {yearOptions.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
            {year === currentYear + 1 && isToYear && isFinanceReport && " (Future)"}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DynamicYearSelector;